import { render, staticRenderFns } from "./StudentItem.vue?vue&type=template&id=3d586aa9&scoped=true&"
import script from "./StudentItem.vue?vue&type=script&lang=js&"
export * from "./StudentItem.vue?vue&type=script&lang=js&"
import style0 from "./StudentItem.vue?vue&type=style&index=0&id=3d586aa9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d586aa9",
  null
  
)

export default component.exports